var Preloader = {
	
	fontsReady : false,
	imagesReady : false,
	interval : false,
	startTime: new Date().getTime(),
	minTime : 2,
	diffSeconds : 0,

	main : function(){

		WebFont.load({
			google: {
				families: [ 'Source+Sans+Pro:ital,wght@0,300;0,400;0,600;0,700;1,400' ]
			},
			custom: {
			    families: [ 'Degular' ]
			},
			active: function( familyName, fvd ){
				Preloader.fontsReady = true;
				Preloader.checkFinish();
			}
		});

		// If just loaded
		var cookie = Cookie.get( 'siteLoaded' );		
		if( cookie === true ) Preloader.minTime = 0;

		document.addEventListener( 'DOMContentLoaded', function(){
			Preloader.bind();
		});

	},

	bind : function(){

		// Just has preloader
		var preloader = document.getElementById( 'page-preloader' );
		if( preloader === null ) return true;

		// Minimum time
		Preloader.interval = setInterval(function(){
			var actualTime = new Date().getTime();
			Preloader.diffSeconds = ( actualTime - Preloader.startTime ) / 1000;
			Preloader.checkFinish();
		}, 100 );

		// Images loaded
		imagesLoaded(document.querySelector('body'), function(){
			Preloader.imagesReady = true;
			Preloader.checkFinish();
		});
	
	},

	checkFinish : function(){

		if( Preloader.fontsReady === true && Preloader.imagesReady === true && Preloader.diffSeconds >= Preloader.minTime ){
	
			Cookie.set( 'siteLoaded', true, '' );
			clearInterval( Preloader.interval );
			Preloader.closeLoader();
		}
	
	},

	closeLoader : function(){
		var preloader = document.getElementById( 'page-preloader' );
		if( preloader ){
			preloader.remove();
		}
	}

};
Preloader.main();